import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=3bb2b172&scoped=true"
import script from "./CartIcon.vue?vue&type=script&lang=js"
export * from "./CartIcon.vue?vue&type=script&lang=js"
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=3bb2b172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2b172",
  null
  
)

export default component.exports